import { cn } from '@/utils/styles';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function Container({ children, className }: Props) {
  return (
    <main
      id="container"
      className={cn(
        'container flex size-full min-h-full flex-1 grow flex-col items-center',
        className,
      )}>
      {children}
    </main>
  );
}
